if (typeof BSS_B2B != undefined) {
  if (window.location.pathname.includes("/cart")) {
    setTimeout(() => {
      BSS_B2B.observer.cartSubject.listenCartCheckout();
    }, 2000);
  }

  document.addEventListener("cartChange", function () {
    setTimeout(() => {
      BSS_B2B.observer.cartSubject.listenCartCheckout();
    }, 500);
  });

  let cart = document.querySelector(".section--cart-page");
  if (cart) {
    let observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.addedNodes.length) {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
      });
    });
    observer.observe(cart, { childList: true });
  }
  let searchDrawer = document.querySelector(".minicart__holder");
  if (searchDrawer) {
    let observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        BSS_B2B.observer.cartSubject.listenCartCheckout();
      });
    });
    observer.observe(searchDrawer, { childList: true });
  }
}

// TODO: mutaion trigger when open search, set attr CP, 
document.addEventListener("DOMContentLoaded", () => {
  const searchContainers = document.querySelectorAll(
    '[data-dfd-view="Search"]'
  );

  searchContainers.forEach((container) => {
    function mutationCallback(mutationList) {
      mutationList.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          container.classList.contains("dfd-animate")
        ) {
          console.log(
            'Container with data-dfd-view="Search" detected with dfd-animate:',
            container
          );
          handleSearchLogic(container);
        }
      });
    }

    const observer = new MutationObserver(mutationCallback);
    observer.observe(container, {
      attributes: true,
      attributeFilter: ["class"],
    });

    if (!container) {
      console.warn('not found [data-dfd-view="Search"]');
    }

    // even click for suggest btn
    container.addEventListener("click", async (event) => {
      const suggestElement = event.target.closest(
        '[dfd-click="click-suggestion"]'
      );
      if (suggestElement) {
        console.log("Click suggest detected on:", suggestElement);
        handleSearchLogic(container);
      }
    });
  });

  async function handleSearchLogic(container) {
    const cardWrappers = container.querySelectorAll(".dfd-card-row");

    cardWrappers.forEach(async (wrapper) => {
      const cardPricing = wrapper.querySelector(".dfd-card-pricing");
      const productBtn = wrapper.querySelector(".dfd-cart-add-button button");

      if (cardPricing && productBtn) {
        const dataItemStr = productBtn.getAttribute("data-item");
        if (dataItemStr) {
          try {
            const data = JSON.parse(dataItemStr);
            const productId = data.id;

            cardPricing.setAttribute("bss-b2b-product-id", productId);
            cardPricing.setAttribute("bss-b2b-product-price", "true");

            const res = await BSS_B2B.storage.productStorage.load();
            if (
              res.notExistProductIds?.length ||
              res.productIds?.length ||
              res.variantIds?.size
            ) {
              await BSS_B2B.observer.productSubject.notifyObserver(
                "LazyProduct",
                "LoadedLazyProduct",
                {
                  ...res,
                }
              );
              console.log("Notified observer with:", { productId, res });
            }
          } catch (e) {
            console.error("error parse data-item JSON:", e);
          }
        }
      }
    });
  }
});
